<template>
  <div id="serviceFooter" class="grid grid__item_span-12 p0 m0 clear">
    <div class="inner grid grid__item_span-12 clear">

      <a id="back" href="/services"><span id="image"><img src="../../../static/left-arrow.svg" alt="" title="" /></span><span class="message txtWhite uppercase grid grid__item_span-12 clear m0 p0">Back to services</span></a>

      <div id="contactsec" class="grid grid__item_span-12 m0 p0">
        <div class="txtWhite grid grid__item_span-4 m0 p0">
          <h2 class="txtWhite uppercase">Know exactly what you want to collaborate on?</h2>
           <p class="txtWhite">Let's chat.</p>
        </div>
        <div class="details grid grid__item_span-4 m0 p0 txtWhite">
          <h3 v-if="mobileClass === 'deviceActive'" itemprop="telephone"><a href="tel:06 3531983">06 353 1983</a></h3>
          <h3 v-else itemprop="telephone">+64 6 353 1983</h3>
          <h3 itemprop="email"><a href="mailto:info@bsd.nz" onclick="ga('send', 'event', 'BSD Email - services page', 'Click');">info@bsd.nz</a></h3>
        </div>
      </div>

    </div>
  </div>

</template>

<script>

var inViewport = require('vue-in-viewport-mixin')

export default {
  name: 'Headline',
  props: [
    'item'
  ],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      mobileClass: ''
    }
  },
  methods: {
    mobileDetect () {
      var browserSize = window.innerWidth || document.body.clientWidth
      console.log(browserSize)
      var deviceMaxSize = 1024
      if (browserSize < deviceMaxSize) {
        this.mobileClass = 'deviceActive'
      }
    },
    addClass (state) {
      // console.log('running')
      // console.log(state)
      var footerState = state
      var projectWrap = document.getElementById('casestudyFooter')
      // var projectFooter = document.getElementById('casestudyFooter')
      // var wrap = document.getElementById('wrap')
      if (footerState === 'YES') {
        // console.log('this')
        // wrap.style.backgroundColor = '#141719'
        // projectFooter.style.position = 'fixed'
        projectWrap.classList.add('openFooter')
      } else {
        // console.log('that')
        // wrap.style.backgroundColor = '#EFF0F1'
        // projectFooter.style.position = 'static'
        projectWrap.classList.remove('openFooter')
      }
    }
  },
  mixins: [
    inViewport
  ],
  watch: {
    /* 'inViewport.now': function (visible) {
      // console.log('This component is ' + (visible ? 'in-viewport' : 'hidden'))
      // var projectFooter = document.getElementById('casestudyFooter')
      var state = ''
      if (visible === true) {
        // console.log('YES')
        state = 'YES'
        // console.log(state)
        return this.addClass(state)
      } else {
        // console.log('no luck')
        state = 'NO'
        // console.log(state)
        return this.addClass(state)
      }
    } */
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/project/serv_Footer.vue